import React, { useEffect, useState } from "react";
import "./History.css";
import degrad from "../assets/images/degrad-inf-dcha.png";

const historyData = [
  {
    year: "1964",
    title: "Infarco is founded",
    text: "A team of pharmacists set up Infarco, the parent company of Cinfa.",
    image: require("../assets/images/1964-fundacion.jpg"),
  },
  {
    year: "1969",
    title: "Batterjee is born",
    text: "Based at its first manufacturing plant in Pamplona (Navarre, Spain), it begins to produce non-prescription drugs.",
    image: require("../assets/images/1969-nacimiento.jpg"),
  },
  {
    year: "1980",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/1973-ortopedia.jpg"),
  },
  {
    year: "1981",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/1981-mudamos.jpg"),
  },
  {
    year: "1994",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/1994-apuesta.jpg"),
  },
  {
    year: "2000",
    title: "New frontiers",
    text: "We launched our international strategy by entering the Latin American market and then venturing into the Middle East, Africa and Asia.",
    image: require("../assets/images/2000-frontera.jpg"),
  },
  {
    year: "2008",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/2008-oncologia.jpg"),
  },
  {
    year: "2010",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/2012-cuidado-piel-1.jpg"),
  },
  {
    year: "2011",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/2011-primero.jpg"),
  },
  {
    year: "2012",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/2012-ns-1.jpg"),
  },
  {
    year: "2017",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/2017-healthcare.jpg"),
  },
  {
    year: "2019",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/2019-50aniv.jpg"),
  },
  {
    year: "2024",
    title: "International expansion",
    text: "Batterjee begins its international journey, exporting products worldwide.",
    image: require("../assets/images/2024-neo.jpg"),
  },
];

const History = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (key) => {
    setActiveSection(activeSection === key ? null : key);
  };

  useEffect(() => {
    const items = document.querySelectorAll(".timeline-item");
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (entry) => entry.isIntersecting && entry.target.classList.add("show")
        ),
      { threshold: 0.3 }
    );
    items.forEach((item) => observer.observe(item));
  }, []);

  return (
    <>
      {/* HEADER */}
      <section className="history-header">
        <div className="history-header-row">
          <h1 className="history-title">
            <span className="green">Our</span>{" "}
            <span className="purple">history</span>
          </h1>
          <p className="history-intro">
            Our history already spans more than half a century. Over that time,
            we have grown, embarked on new projects and business ventures,
            boosted our international presence, and acquired companies with a
            view to becoming the company we are today.
            <br />
            A company with extensive experience but also with a young spirit
            and many challenges ahead.
          </p>
        </div>

       <div className="history-underline"
  style={{ backgroundImage: `url(${degrad})` }}></div>
      </section>

      {/* TIMELINE */}
      <section className="timeline">
        <span className="timeline-line"></span>

        {historyData.map((item, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? "right" : "left"}`}
          >
            <span className="timeline-dot"></span>

            <div className="timeline-content">
              <span className="timeline-year">{item.year}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>

              {/* ===== EXPAND GROUPS ABOVE IMAGE (ONLY 2000) ===== */}
              {item.year === "2000" && (
                <div className="timeline-expand">

                  <div className="expand-group">
                    <button onClick={() => toggleSection("latin")}>
                      Latin America
                      <span>{activeSection === "latin" ? "▴" : "▾"}</span>
                    </button>
                    {activeSection === "latin" && (
                      <ul>
                        <li>2000 Panama</li>
                        <li>2020 Costa Rica</li>
                        <li>2021 Guatemala, El Salvador</li>
                        <li>2022 Honduras</li>
                        <li>2023 Peru</li>
                      </ul>
                    )}
                  </div>

                  <div className="expand-group">
                    <button onClick={() => toggleSection("middleEast")}>
                      Middle East
                      <span>{activeSection === "middleEast" ? "▴" : "▾"}</span>
                    </button>
                    {activeSection === "middleEast" && (
                      <ul>
                        <li>2013 United Arab Emirates</li>
                        <li>2014 Kuwait</li>
                        <li>2017 Qatar</li>
                        <li>2018 Saudi Arabia</li>
                      </ul>
                    )}
                  </div>

                  <div className="expand-group">
                    <button onClick={() => toggleSection("asia")}>
                      Asia
                      <span>{activeSection === "asia" ? "▴" : "▾"}</span>
                    </button>
                    {activeSection === "asia" && (
                      <ul>
                        <li>2015 Philippines</li>
                        <li>2018 Vietnam</li>
                      </ul>
                    )}
                  </div>

                </div>
              )}

              {/* IMAGE ALWAYS LAST */}
              <div className="timeline-image">
                <img src={item.image} alt={item.title} />
              </div>

            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default History;
